/**
 * Layout commun des pages du parcours d'ajout : contenu centré + bouton retour dashboard.
 */
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ReactNode } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "../../common/Button";

type AddWidgetLayoutProps = {
  children: ReactNode;
  footer?: ReactNode;
};

export function AddWidgetLayout({ children, footer }: AddWidgetLayoutProps) {
  const navigate = useNavigate();

  return (
    <div className="p-4 min-h-screen flex flex-col">
      <div className="flex-1">{children}</div>
      <div className="mt-8 flex justify-center">
        {footer ?? (
          <Button
            size="full"
            className="max-w-xl"
            onClick={() => navigate("/")}
          >
            Retourner au dashboard
          </Button>
        )}
      </div>
    </div>
  );
}

type ChooseWidgetButtonProps = {
  label: string;
  onClick: () => void;
};

export function ChooseWidgetButton({
  label,
  onClick,
}: ChooseWidgetButtonProps) {
  return (
    <Button variant="secondary" onClick={onClick} className="mt-4 px-8">
      <span className="inline-flex items-center gap-2 normal-case tracking-normal">
        <FontAwesomeIcon icon="plus" />
        {label}
      </span>
    </Button>
  );
}

export const widgetSelectClassName =
  "w-full rounded-lg border border-grey-medium focus:outline-none focus:border-tertiary px-4 py-2 bg-white text-default-text";
